import React from 'react';
import { Form, InputNumber, Switch, Row, Col, Divider, Alert } from 'antd';

export const FeedbackSettings: React.FC = () => {
  return (
    <>
      <Alert
        message="О настройках отзывов"
        description="Система автоматически отправляет запросы на отзыв клиентам после выполнения заказа. Отзывы с высокими оценками (4-5★) могут одобряться автоматически."
        type="info"
        showIcon
        style={{ marginBottom: 24 }}
      />

      <Divider orientation="left">Общие настройки</Divider>
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item
            label="Включить запросы отзывов"
            name="feedback_enabled"
            valuePropName="checked"
            help="Автоматическая отправка запросов на отзыв после выполнения заказа"
          >
            <Switch 
              checkedChildren="Включено" 
              unCheckedChildren="Выключено" 
            />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            label="Автоодобрение отзывов 4-5★"
            name="auto_approve_high_ratings"
            valuePropName="checked"
            help="Отзывы с оценкой 4-5 звёзд без мата одобряются автоматически"
          >
            <Switch 
              checkedChildren="Включено" 
              unCheckedChildren="Выключено" 
            />
          </Form.Item>
        </Col>
      </Row>

      <Divider orientation="left">Тайминги</Divider>
      <Row gutter={16}>
        <Col xs={24} md={8}>
          <Form.Item
            label="Задержка первого запроса (часы)"
            name="feedback_delay_hours"
            rules={[
              { required: true, message: 'Укажите время' },
              { type: 'number', min: 1, max: 168, message: 'От 1 до 168 часов (1 неделя)' }
            ]}
            help="Через сколько часов после выполнения заказа отправить запрос"
          >
            <InputNumber 
              min={1} 
              max={168} 
              style={{ width: '100%' }}
              addonAfter="ч"
            />
          </Form.Item>
        </Col>

        <Col xs={24} md={8}>
          <Form.Item
            label="Напоминание (часы)"
            name="feedback_reminder_hours"
            rules={[
              { required: true, message: 'Укажите время' },
              { type: 'number', min: 1, max: 336, message: 'От 1 до 336 часов (2 недели)' }
            ]}
            help="Через сколько часов после первого запроса отправить напоминание"
          >
            <InputNumber 
              min={1} 
              max={336} 
              style={{ width: '100%' }}
              addonAfter="ч"
            />
          </Form.Item>
        </Col>

        <Col xs={24} md={8}>
          <Form.Item
            label="Максимум попыток"
            name="feedback_max_attempts"
            rules={[
              { required: true, message: 'Укажите количество' },
              { type: 'number', min: 1, max: 5, message: 'От 1 до 5 попыток' }
            ]}
            help="Сколько раз максимум отправлять запрос на отзыв"
          >
            <InputNumber 
              min={1} 
              max={5} 
              style={{ width: '100%' }}
              addonAfter="раз"
            />
          </Form.Item>
        </Col>
      </Row>

      <Alert
        message="Рекомендации"
        description={
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            <li><strong>Задержка первого запроса:</strong> 24-72 часа — клиент успеет оценить качество</li>
            <li><strong>Напоминание:</strong> 48-96 часов после первого запроса</li>
            <li><strong>Максимум попыток:</strong> 1-2 раза, чтобы не надоедать клиенту</li>
          </ul>
        }
        type="success"
        showIcon
        style={{ marginTop: 16 }}
      />
    </>
  );
};